import { SortParams, PaginationParams, SerializedPagination } from '../domain/pagination';

export function serializeSortParams(sort: SortParams):string[] {
  return Object.entries(sort).map(([field, order]) => `${field},${order}`);
}

export function serializePagination(params: PaginationParams): SerializedPagination {
  const pagination: SerializedPagination = {};

  if (params.page || params.size) {
    pagination.page = params.page || 0;
  }

  if (params.size) {
    pagination.size = params.size;
  }

  if (params.sort) {
    pagination.sort = serializeSortParams(params.sort);
  }

  return pagination;
}
